import React from 'react';

import ProtectedData from 'pages/item/v2/components/ProtectedData';
import isEmpty from 'utils/is-empty';
import Utils from 'utils/Utils';

import Link from '../Link';
import TablePanel from '../TablePanel';

export interface PackageProps {
    affectedPackage:
        | {
              OS: string;
              OSVersion: string;
              arch: string;
              packageName: string;
              packageVersion: string;
              packageFilename: string;
          }[]
        | undefined;
}

const Package: React.FC<PackageProps> = ({ affectedPackage }) => {
    if (isEmpty(affectedPackage)) {
        return null;
    }

    return (
        <TablePanel
            data={affectedPackage}
            config={[
                {
                    name: 'OS',
                    sortField: 'OS',
                    width: '120px',
                    style: { whiteSpace: 'pre' },
                    field({ OS }) {
                        return <Link href={`/search?query=affectedPackage.OS:"${OS}"`} label={OS} />;
                    }
                },
                {
                    name: 'Version',
                    sortField: 'OSVersion',
                    width: '60px',
                    field({ OS, OSVersion }) {
                        return (
                            <Link
                                href={`/search?query=affectedPackage.OS:${OS} AND affectedPackage.OSVersion:${OSVersion}`}
                                label={OSVersion}
                            />
                        );
                    }
                },
                {
                    name: 'Architecture',
                    sortField: 'arch',
                    width: '60px',
                    field({ OS, OSVersion, arch }) {
                        return (
                            <Link
                                href={`/search?query=affectedPackage.OS:${OS} AND affectedPackage.OSVersion:${OSVersion} AND affectedPackage.arch:${arch}`}
                                label={arch}
                            />
                        );
                    }
                },
                {
                    name: 'Package',
                    sortField: 'packageName',
                    field({ packageName }) {
                        return (
                            <Link
                                href={`/search?query=affectedPackage.packageName:${packageName}`}
                                label={packageName}
                            />
                        );
                    }
                },
                {
                    name: 'Version',
                    sortField: 'packageVersion',
                    field({ operator, packageVersion }) {
                        return (
                            <>
                                <ProtectedData data={operator}>{Utils.htmlDecode(operator)}</ProtectedData>
                                &nbsp;
                                <ProtectedData data={packageVersion} />
                            </>
                        );
                    }
                },
                {
                    name: 'Filename',
                    sortField: 'packageFilename',
                    field({ packageFilename }) {
                        return (
                            <Link
                                href={`/search?query=affectedPackage.packageFilename:${packageFilename}`}
                                label={packageFilename}
                            />
                        );
                    }
                }
            ]}
        />
    );
};

export default Package;
